import { useEffect, useMemo } from 'react';

import { useQuestionnaireFormik } from '../../../../../common';
import { CHILD_BEHAVIOR_ISSUES_SCHEMA, ChildBehaviorIssuesField } from '../../../../../../common';
import { intakeQuestionnaireActions } from '../../../../../../../store';
import { INTAKE_TAB_IDS } from '../../../../constants';
import { useIntakeQuestionnaireLoading } from '../../../../hooks';
import { useIntakeChildBehaviorIssues } from '../hooks';
import { setCurrentChildBehaviorIssuesFormValue } from '../utils';

import type { ChildBehaviorIssuesFormValues } from '../../../../../../common';

export default function ChildBehaviorIssuesSection() {
  const { childBehaviorIssues, save, extraRequirementMet, hasNonFormikSavedValues } =
    useIntakeChildBehaviorIssues();
  const isLoading = useIntakeQuestionnaireLoading();
  const initialValues = useMemo<ChildBehaviorIssuesFormValues>(
    () => ({ child_behavior_issues: childBehaviorIssues }),
    [childBehaviorIssues],
  );
  const formik = useQuestionnaireFormik({
    tabId: INTAKE_TAB_IDS.CHILD,
    initialValues,
    validationSchema: CHILD_BEHAVIOR_ISSUES_SCHEMA,
    extraRequirementMet,
    hasNonFormikSavedValues,
    updateTabStatus: intakeQuestionnaireActions.updateIntakeTabStatus,
  });
  useEffect(() => {
    setCurrentChildBehaviorIssuesFormValue(formik.values.child_behavior_issues);
    return () => setCurrentChildBehaviorIssuesFormValue(null);
  }, [formik.values.child_behavior_issues]);

  const handleBlur = () => {
    if (!CHILD_BEHAVIOR_ISSUES_SCHEMA.isValidSync(formik.values)) {
      return;
    }
    void save(formik.values.child_behavior_issues.trim());
  };

  return <ChildBehaviorIssuesField disabled={isLoading} formik={formik} onBlur={handleBlur} />;
}
